import React from "react";

export const VerificationCodeInput = ({ register, errors, name = 'verificationCode', displayInlineError = false }) => {
    return <div className='form-group mb-0'>
        <input className={`form-control ${errors[name] && 'upsell-input-invalid'}`}
            type="text" placeholder="Code"
            inputMode="numeric" pattern="[0-9]*"
            autoComplete="one-time-code" maxLength="9"
            {...register(name, { required: "Verification code is required" })}
        />

        {displayInlineError && errors[name] && (
            <div className="upsell-input-error">{errors[name].message}</div>
        )}
    </div>;
};